module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("document-navigation " + (_vm.isActive ? 'document-navigation--active' : ''))
  }, [_c('div', {
    staticClass: "document-navigation__image document-navigation__image--prev"
  }, [(_vm.prevDoc !== undefined) ? [_c('img', {
    attrs: {
      "src": ("https://docs-cdn.signable.co.uk/large/" + (_vm.prevDoc.fingerprint) + "-0.jpg")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "document-navigation__button document-navigation__button--prev",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goToPrevDoc
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-left",
      "height": "14",
      "width": "14"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "document-navigation__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.prevDoc.title))]), _vm._v(" "), _c('span', {
    staticClass: "document-navigation__arrow"
  })])] : [_c('div', {
    staticClass: "document-navigation__image-placeholder"
  })]], 2), _vm._v(" "), (_vm.currentDoc !== undefined) ? _c('div', {
    staticClass: "document-navigation__image"
  }, [_c('img', {
    attrs: {
      "src": ("https://docs-cdn.signable.co.uk/large/" + (_vm.currentDoc.fingerprint) + "-0.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "document-navigation__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentDoc.title))]), _vm._v(" "), _c('span', {
    staticClass: "document-navigation__arrow"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "document-navigation__image document-navigation__image--next"
  }, [(_vm.nextDoc !== undefined) ? [_c('img', {
    attrs: {
      "src": ("https://docs-cdn.signable.co.uk/large/" + (_vm.nextDoc.fingerprint) + "-0.jpg")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "document-navigation__button document-navigation__button--next",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goToNextDoc
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right",
      "height": "14",
      "width": "14"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "document-navigation__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.nextDoc.title))]), _vm._v(" "), _c('span', {
    staticClass: "document-navigation__arrow"
  })])] : [_c('div', {
    staticClass: "document-navigation__image-placeholder"
  })]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4cdb99a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentNavigation.vue
// module id = 1063
// module chunks = 1